import React, { useEffect, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import { Col, Row, Form } from "react-bootstrap";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { useNavigate } from 'react-router-dom';
import Text from '../../components/inputTxt/Text';
import UploadIMG from "../../components/uploads/UploadIMG";
import { getBannerByID, createBanner, updateBannerByID } from "../../api/banner_api.js";
import Calendarpicker from "../../components/calendars/Calendarpicker";
import { formatDateYYYYMMDD,formatDateDDMMYYYY } from "../../utils/formatDate.js";
import UploadVideo from '../../components/uploads/UploadVideo.js';
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmChange,
    alertConfirmSave,
    alertSaved,
    alertCancel,
    alertNotFound
} from "../../components/alertValid/AlertValid.js"
import CustomCKEditor from '../../components/ckEditor/CustomCKEditor.js';
import CalendarToday from '../../components/calendars/CalendarToday.js';

function AddEditBannerHome() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [txtEnTitle, setTxtEnTitle] = useState('');
    const [txtThTitle, setTxtThTitle] = useState('');
    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [images2, setImages2] = useState([]);
    const [imagesFromApi2, setImagesFromApi2] = useState([]);
    const [active, setActive] = useState(true);
    const [activeIMG, setActiveIMG] = useState(true);
    const [inputDateStart, setInputDateStart] = useState(null);
    const [inputDateEnd, setInputDateEnd] = useState(null);
    const [inputDateStartFromApi, setInputDateStartFromApi] = useState(null);
    const [inputDateEndFromApi, setInputDateEndFromApi] = useState(null);

    const [selectedDate, setSelectedDate] = useState('');
    const [status, setStatus] = useState('inactive');


    function ChangesetValueDateStart(value) {
        setInputDateStart(value);
    }
    function ChangesetValueDateEnd(value) {
        setInputDateEnd(value);
    }

    const [inputForm, setInputForm] = useState({
        inp2: "",
        inp3: ""
    });
    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleSelectedImages2 = (images) => {
        setImages2(images);
    };
    const handleSelectedRemoveImg2 = (data) => {
        setImages2(data);
    };

    const handleChangeInput50 = async (event, inpName) => {
        const inputValue = event.target.value;
        if (inputValue.length >= 50) {
            const result = await alertOverLimit();
            if (result.isConfirmed) {
                const trimmedValue = inputValue.substring(0, 50); 
                const finalValue = trimmedValue.substring(0); 
                if (inpName == 'enTitle') {
                    setTxtEnTitle(finalValue);
                } else if (inpName == 'thTitle') {
                    setTxtThTitle(finalValue);
                }
            } else {
                if (inpName == 'enTitle') {
                    setTxtEnTitle(inputValue);
                } else if (inpName == 'thTitle') {
                    setTxtThTitle(inputValue);
                }
            }
        } else {
            if (inpName == 'enTitle') {
                setTxtEnTitle(inputValue);
            } else if (inpName == 'thTitle') {
                setTxtThTitle(inputValue);
            }
        }
    };

    const handleClickRadioIMG = async () => {
        const result = await alertConfirmChange();
        if (result.isConfirmed) {
            setActiveIMG(true)
            setImages2([])
        }
    }

    const handleClickRadioVdo = async () => {
        const result = await alertConfirmChange();
            if (result.isConfirmed) {
                setActiveIMG(false)
                setImages1([])
            }
    }

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }


    const createBannerData = async () => {
        try {
            let body = {
                banner_category: 'hero_banner',
                banner_subcategory: 'home',
                supertext_en: txtEnTitle,
                supertext_th: txtThTitle,
                format: images1.length > 0 ? 'image' : images2.length > 0 ?'video' : 'iframe',
                description_en: txtEnDesc,
                description_th: txtThDesc,
                file: images1.length > 0 ? images1 : images2.length > 0 ? images2 : null,
                publish_date: inputDateStart ? new Date(formatDateYYYYMMDD(inputDateStart)).toISOString() : '',
                active: active == false ? 0 : 1,
            };
            if (
                !body.supertext_en ||
                !body.supertext_th ||
                !body.description_en ||
                !body.description_th ||
                !body.file ||
                body.file.length == 0 ||
                !body.publish_date
            ) {
                await alertValidate();
            } else {
                const result = await alertConfirmSave();
                if (result.isConfirmed) {
                 
                    await setLoading(true);
                    const response = await createBanner(body);
                    console.log(`respinse in create banner`)
                    if (response.data.status == "success") {
                        setLoading(false)

                        const result = await alertSaved();
                        if (result.isConfirmed) {
                            navigateToBack("/infoHeroBannerHome");
                        }
                    }
                    setLoading(false)
              
                }
            }
        } catch (error) {
            setLoading(false)
        }
    };

    const updateBannerData = async (id) => {
        try {
            let body = {
                banner_category: 'hero_banner',
                banner_subcategory: 'home',
                supertext_en: txtEnTitle,
                supertext_th: txtThTitle,
                format: images1.length > 0 ? 'image' : images2.length>0 ?'video' : 'iframe',
                description_en: txtEnDesc,
                description_th: txtThDesc,
                file: images1.length > 0 ? images1 : images2.length > 0 ? images2 : null,
                publish_date: inputDateStart ? new Date(formatDateYYYYMMDD(inputDateStart)).toISOString() : '',
                active: active == false ? 0 : 1,
              };
              if (
                !body.supertext_en ||
                !body.supertext_th ||
                !body.description_en ||
                !body.description_th ||
                !body.file ||
                body.file.length == 0 ||
                !body.publish_date
            ) {
                await alertValidate();
            }
            else {
                const result = await alertConfirmSave();
                if (result.isConfirmed) {
                  await setLoading(true);
                  const response = await updateBannerByID(id, body);
                  if (response.data.status == "success") {
                    setLoading(false)
                    const res = await alertSaved();
                      if (res.isConfirmed) {
                        navigateToBack("/infoHeroBannerHome");
                      }
                  }
                  else{
                    setLoading(false)
                    const res = await alertNotFound();
                        if (res.isConfirmed) {
                            // window.location.href = '/backoffice/infoHeroBannerHome'
                            navigateToBack('/infoHeroBannerHome')
                        } else {
                            navigateToBack('/infoHeroBannerHome')
                            // window.location.href = '/backoffice/infoHeroBannerHome'
                        }
                  }
                }
            }
        } catch(error) {
            setLoading(false)
        }
       
      };

    const handleActiveBtn = async (idData) => {
        if (idData) {
            updateBannerData(idData);
        } else {
            createBannerData();
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
            if (res.isConfirmed) {
                navigateToBack("/infoHeroBannerHome");
            }
            else { }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }
    const getDataBanner = async (id) => {
        await setLoading(true);
        const respon = await getBannerByID(id);
        if(!respon) {
            const res = await alertNotFound();
            if (res.isConfirmed) {
                // window.location.href = '/backoffice/infoherobannerhome'
                navigateToBack("/infoHeroBannerHome");
            } else {
                // window.location.href = '/backoffice/infoherobannerhome'
                navigateToBack("/infoHeroBannerHome");
            }
        } 
        setTimeout(async () => {
          await setLoading(false);
        }, 1000);
    
        let dataPreview = respon.data.data;
    
        setEditId(dataPreview._id)
        setTxtEnTitle(dataPreview.supertext_en)
        setTxtThTitle(dataPreview.supertext_th)
        setTxtEnDesc(dataPreview.description_en)
        setTxtThDesc(dataPreview.description_th)
        setInputDateStart(new Date(dataPreview.publish_date))
        setInputDateStartFromApi(formatDateDDMMYYYY(dataPreview.publish_date))
        setActive(dataPreview.active === 1 ? true : false);
        
        if(dataPreview.format =='image')
        {
            setActiveIMG(true)
            setImagesFromApi1([{
                id: 0,
                status: false,
                src:
                    dataPreview.data === null ||
                    dataPreview.data === ""
                    ? ''
                    : dataPreview.data,
                file: dataPreview.data ? await urlToBlob(dataPreview.data) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }]);
        }
        if(dataPreview.format =='video')
        {
            setActiveIMG(false)
            setImagesFromApi2([{
                id: 0,
                status: false,
                src:
                    dataPreview.data === null ||
                    dataPreview.data === ""
                    ? ''
                    : dataPreview.data,
                file: dataPreview.data ? await urlToBlob(dataPreview.data) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'video/mp4' //hard code ให้ผ่าน validate
            }])
        }   
    };

    // useEffect(() => {
        //     if (inputDatePublish) {
        //       const today = new Date()
        //       console.log(today,inputDatePublish)
        //       setActive(isSameDate(new Date(),date)); // หากตรงกับวันนี้ ให้สถานะเป็น active
        //     }
        // }, [inputDatePublish]);
        const setDate = (inputname,date) => {            
            console.log('setDate',inputname,date)
        };
        const handleDateChange = (date) => {
            setInputDateStart(date); // อัปเดตวันที่ที่เลือก
            const today = new Date()
            console.log(today,date)
            setActive(isSameDate(new Date(),date)); // หากตรงกับวันนี้ ให้สถานะเป็น active
        };
        function isSameDate(date1, date2) {
            //console.log(date1,date2)
            return (
                date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getDate() === date2.getDate()
            );
        }
      
    useEffect(() => {
        let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
                getDataBanner(id);
                setEditId(id);
            }
    }, [])

  return (
    <>
        <style>
            {`
                .form-check-inline {
                    display: inline-block;
                    margin: 0 !important;
                }
                .form-check-inline.radio-item1 {
                    display: inline-block;
                    margin: 0 1rem 0 1rem !important;
                }
                .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                    height: 200px;
                }
            `}
        </style>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"BANNER"} />
        <Menu
            parentmenu={"infoBanner"}
            activemenu={"infoHeroBannerHome"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            {editId ? (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-banner.png" className="ic-user01 me-2" alt="" />
                                EDIT HERO BANNER
                            </font>
                            ) : (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-banner.png" className="ic-user01 me-2" alt="" />
                                ADD HERO BANNER
                            </font>
                            )}
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                    Hero Banner Home
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Text
                                    value={txtEnTitle}
                                    onChange={(e) => handleChangeInput50(e,'enTitle')}
                                    placeholder="Title / Super Text *"
                                />
                            </Col>
                            <Col xs={6}>
                                <Text
                                    value={txtThTitle}
                                    onChange={(e) => handleChangeInput50(e,'thTitle')}
                                    placeholder="ข้อเรื่อง *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtEnDesc}
                                    onChange={(newData) => {
                                        setTxtEnDesc(newData);
                                    }}
                                    placeholder="Description *"
                                />
                            </Col>
                            <Col xs={6}>
                                <CustomCKEditor
                                    data={txtThDesc}
                                    onChange={(newData) => {
                                        setTxtThDesc(newData);
                                    }}
                                    placeholder="คำอธิบาย *"
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Image / VDO <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                            <Form>
                                {["radio"].map((type) => (
                                    <div key={`inline1-${type}`} className="mt-2 mb-3">
                                        <Row className="align-items-center">
                                            <Col xs={1} className="px-0">
                                                <Form.Check
                                                    className="fontLight font-size03 colorBlack01 checked"
                                                    inline
                                                    label="Image"
                                                    name="group1"
                                                    type={type}
                                                    id={`inline1-${type}-1`}
                                                    checked={activeIMG}
                                                    onChange={(e) => {
                                                        handleClickRadioIMG()
                                                        }
                                                    }   
                                                />
                                            </Col>
                                            <Col xs={5}>
                                            {activeIMG &&
                                                <UploadIMG
                                                    limit={1}
                                                    onSelectedImages={handleSelectedImages1}
                                                    images={imagesFromApi1}
                                                    txtDetail={"jpg. / 1920x600 px , limit size 5MB"}
                                                    removeImg={handleSelectedRemoveImg1}
                                                    // maxWidth={1600}
                                                />
                                            }
                                            </Col>
                                            <Col xs={1} className="px-0"> 
                                                <Form.Check
                                                    className="fontLight font-size03 colorBlack01"
                                                    inline
                                                    label="Video"
                                                    name="group1"
                                                    type={type}
                                                    id={`inline1-${type}-2`}
                                                    checked={!activeIMG}
                                                    onChange={(e) => {
                                                        handleClickRadioVdo()
                                                        }
                                                    }
                                                />
                                            </Col>
                                            <Col xs={5}>
                                            {!activeIMG &&
                                                <UploadVideo
                                                    limit={1}
                                                    onSelectedFile={handleSelectedImages2}
                                                    selectFiles={imagesFromApi2}
                                                    txtDetail={".mp4, .mov / 1920x600 px , limit size 5MB"}
                                                    removeImg={handleSelectedRemoveImg2}
                                                />
                                            }
                                            </Col>
                                        </Row>
                                        
                                        
                                    </div>
                                ))}
                            </Form>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row className='mt-4'>
                            <Col xs={6} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01">
                                        Publish Date <span className=' colorRed'>*</span>
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        {/* <CalendarToday
                                            dataDate={inputDateStartFromApi??null}
                                            setDatePicker={setinput}
                                            inputname={"inp2"}
                                            ChangesetValueDate={ChangesetValueDateStart}
                                            inputDate={inputDateStart}
                                            minDate={new Date()}
                                        /> */}
                                        <CalendarToday
                                            dataDate={inputDateStartFromApi || null}
                                            setDatePicker={setDate} // Pass date change handler
                                            inputname={"inp2"}
                                            ChangesetValueDate={handleDateChange}
                                            inputDate={inputDateStart}
                                            minDate={new Date()} // Ensure past dates are disabled
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='ms-1 mt-4'>
                            <Col xs={12} className="p-0">
                                <label className="fontLight font-size03 colorBlack01">
                                Status
                                </label>
                            </Col>
                        </Row>
                        <Form className="ml-1">
                            {["radio"].map((type) => (
                                <div key={`inline3-${type}`} className="mt-2 mb-3">
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01 checked radio-item1"
                                    inline
                                    label="Active"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-1`}
                                    checked={active}
                                    onChange={() => setActive(true)} // Allow manual override to Active
                                />
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01 radio-item1"
                                    inline
                                    label="Inactive"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-2`}
                                    checked={!active}
                                    onChange={() => setActive(false)} // Allow manual override to Inactive
                                />
                                </div>
                            ))}
                        </Form>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                                CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleActiveBtn(editId);
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default AddEditBannerHome;